import React from 'react';

import ErrorIcon from '~/components/icons/ErrorIcon';

export const FallbackComponent: React.FC = () => {
  return <ErrorIcon data-testid="error-indicator" size={30} className="to-grey-700" />;
};
